import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MessageSquare, AlertTriangle, Check } from "lucide-react";

/** Message du répartiteur affiché en grand dans l'app chauffeur, à accuser réception. */
export default function DriverMessages() {
  const [queue, setQueue] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/driver/messages").then((r) => setQueue(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  const msg = queue[0];
  if (!msg) return null;

  const urgent = msg.priority === "urgent";
  const ack = async () => {
    setBusy(true);
    try {
      await api.post(`/driver/messages/${msg.id}/read`);
      setQueue((q) => q.slice(1));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-950 flex flex-col p-4 driver-app" data-testid="driver-message">
      <div className={`flex items-center gap-2 rounded-2xl px-4 py-3 ${urgent ? "bg-red-600" : "bg-blue-600"} text-white`}>
        {urgent ? <AlertTriangle className="w-6 h-6" /> : <MessageSquare className="w-6 h-6" />}
        <div className="font-display text-lg font-extrabold">
          {urgent ? "MESSAGE URGENT" : "Message du répartiteur"}
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center py-6">
        <div className="text-center">
          <p className="font-display text-3xl font-extrabold leading-tight text-white break-words" data-testid="driver-message-text">
            {msg.text}
          </p>
          <div className="mt-4 text-sm text-white/60">
            {msg.from_name} · {(msg.created_at || "").slice(11, 16)}
            {queue.length > 1 && <span className="ml-2">· {queue.length - 1} autre(s) message(s)</span>}
          </div>
        </div>
      </div>

      <button onClick={ack} disabled={busy} data-testid="driver-message-ack"
        className="w-full h-20 rounded-2xl bg-emerald-500 text-slate-900 font-display text-2xl font-extrabold flex items-center justify-center gap-3 active:scale-95 transition-transform disabled:opacity-50">
        <Check className="w-8 h-8" /> COMPRIS
      </button>
    </div>
  );
}
